import useSWR from 'swr';
import { SocialProviders } from 'types/enums';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

/**
 * Хук для получения списка доступных социальных провайдеров
 * @param isModeration Флаг режима модерации
 * @returns Список доступных социальных провайдеров и статус загрузки
 */
export const useSocialProviders = (isModeration?: boolean) => {
  if (isModeration) {
    return {
      data: [
        SocialProviders.google,
        SocialProviders.facebook,
        SocialProviders.twitter,
        SocialProviders.yandex,
        SocialProviders.vk,
      ],
      isLoading: false,
      error: null,
    };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, error, isLoading } = useSWR<SocialProviders[]>(
    process.env.HOST + '/api/auth/social/providers',
    fetcher,
  );

  return { data, isLoading, error };
};
